export default "__VITE_ASSET__DSZKY0zd__"